import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { categoryRecipes } from '../../data/recipes';
import { ArticleService, WPPost } from '../../services/api.services';
import pic1 from '../../assets/images/pic-1.webp';
import pic5 from '../../assets/images/pic-5.webp';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage: React.FC = () => {
  const [currentDate, setCurrentDate] = useState('');
  const [dynamicRecipes, setDynamicRecipes] = useState<any[]>([]);

  useEffect(() => {
    // Generate real-time date for the "Last updated" section
    const date = new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
    setCurrentDate(date);

    // Fetch dynamic recipes for the sidebar
    ArticleService.getAll({ perPage: 8 })
      .then(res => {
         if (res.success && res.data && res.data.length > 0) {
            setDynamicRecipes(res.data);
         }
      })
      .catch(console.error);
  }, []);

  // Use dynamic recipes if available, else fallback to static data
  const sourceRecipes = dynamicRecipes.length > 0 ? dynamicRecipes : categoryRecipes.slice(0, 8);
  const trendingRecipes = sourceRecipes.slice(0, 4);
  const recentRecipes = sourceRecipes.slice(4, 8);

  // Normalise recipe object for rendering (handles both WPPost and static Recipe)
  const renderRecipeItem = (recipe: any) => {
    const isDynamic = 'image' in recipe;
    const img = isDynamic ? (recipe.image || pic1) : recipe.img;
    const title = recipe.title;
    const id = isDynamic ? (recipe.slug || recipe.id) : recipe.id;

    return (
      <div className="widget-recipe-item" key={recipe.id}>
        <Link to={`/blog-details/${id}`} className="widget-recipe-img-link">
          <img src={img} alt={title} className="widget-recipe-img" />
        </Link>
        <div className="widget-recipe-info">
          <h4 className="widget-recipe-title">
            <Link to={`/blog-details/${id}`}>{title}</Link>
          </h4>
          <div className="widget-recipe-meta">
            <span className="stars">★★★★★</span>
            <span className="time">15 MINS</span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <main className="privacy-page-v2">
      <div className="privacy-container-v2">
        {/* Main Content Area */}
        <div className="privacy-main-content">
          <div className="privacy-header-v2">
            <h1 className="privacy-title-v2">PRIVACY POLICY</h1>
            <p className="privacy-updated-v2">LAST UPDATED ON {currentDate.toUpperCase()}</p>
          </div>

          <div className="privacy-body">
            <p className="privacy-intro">
              Welcome to Famous Indian Recipes. We respect your privacy and are committed to protecting your personal data. 
              This privacy policy will inform you as to how we look after your personal data when you visit our website 
              (regardless of where you visit it from) and tell you about your privacy rights and how the law protects you.
            </p>

            <h2 className="privacy-heading">THE DATA WE COLLECT ABOUT YOU</h2>
            <p>
              Personal data, or personal information, means any information about an individual from which that person can be identified. 
              We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:
            </p>
            <ul className="privacy-list">
              <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data</strong> includes email address and telephone numbers.</li>
              <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location.</li>
              <li><strong>Usage Data</strong> includes information about how you use our website, recipes, and services.</li>
            </ul>

            <h2 className="privacy-heading">HOW WE USE YOUR PERSONAL DATA</h2>
            <p>
              We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
            </p>
            <ul className="privacy-list">
              <li>Where we need to perform the contract we are about to enter into or have entered into with you (e.g., subscribing to our newsletter).</li>
              <li>Where it is necessary for our legitimate interests (or those of a third party) and your interests and fundamental rights do not override those interests.</li>
              <li>Where we need to comply with a legal obligation.</li>
            </ul>

            <h2 className="privacy-heading">COOKIES</h2>
            <p>
              You can set your browser to refuse all or some browser cookies, or to alert you when websites set or access cookies. 
              If you disable or refuse cookies, please note that some parts of this website may become inaccessible or not function properly.
            </p>

            <h2 className="privacy-heading">DATA SECURITY</h2>
            <p>
              We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed.
              In addition, we limit access to your personal data to those employees, agents, contractors, and other third parties who have a business need to know.
            </p>

            <h2 className="privacy-heading">CONTACT US</h2>
            <p>
              If you have any questions about this privacy policy or our privacy practices, please contact us via our <Link to="/contact" className="privacy-link">Contact Page</Link>.
            </p>
          </div>
        </div>

        {/* Right Sidebar */}
        <aside className="privacy-sidebar">
          {/* About Me Widget */}
          <div className="sidebar-widget about-widget">
            <img src={pic5} alt="Loganayaki Thamilselvan" className="sidebar-author-img" />
            <p className="sidebar-author-bio">
              Hi, I'm Loganayaki Thamilselvan. Food stylist & photographer. Loves nature and healthy food, and good coffee.
            </p>
            <Link to="/about" className="sidebar-read-more">Read more</Link>
          </div>

          {/* Social Icons Widget */}
          <div className="sidebar-widget social-widget">
            <div className="social-icons">
               <a href="#fb" aria-label="Facebook">
                 <svg viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" /></svg>
               </a>
               <a href="#ig" aria-label="Instagram">
                 <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>
               </a>
               <a href="#tw" aria-label="Twitter">
                 <svg viewBox="0 0 24 24" fill="currentColor"><path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" /></svg>
               </a>
            </div>
          </div>

          {/* Trending Recipes Widget */}
          <div className="sidebar-widget recipes-widget">
            <h3 className="widget-title">CURRENTLY TRENDING</h3>
            <div className="widget-recipe-list">
              {trendingRecipes.map(renderRecipeItem)}
            </div>
          </div>

          {/* Recent Recipes Widget */}
          <div className="sidebar-widget recipes-widget">
            <h3 className="widget-title">RECENT RECIPES</h3>
            <div className="widget-recipe-list">
              {recentRecipes.map(renderRecipeItem)}
            </div>
          </div>

        </aside>
      </div>
    </main>
  );
};

export default PrivacyPolicyPage;
